<template>
    <div class="nosotros">
        <Navbar/>
        <b-container class="section1" fluid>
            <b-row class="mb-5">
                <b-col md="6" class="nosotros-col1 mb-4" align-self="center">
                    <h4>Nosotros</h4>
                    <p><b>Desde nuestros inicios, nos hemos enfocado en un propósito central: transformar la manera en que las personas perciben y viven.</b></p>
                    <p>Enfocados en el mercado que todos los días busca mejorar su calidad de vida, entendemos que una vivienda es mucho más que un espacio físico; es un reflejo del estilo de vida, los valores y las aspiraciones de quienes lo habitan.</p> 
                    <p>Con amplia experiencia en el desarrollo de residenciales de nivel alto y medio, nos distinguimos por nuestra capacidad de combinar un estilo de arquitectura moderna y funcional, con ubicaciones de nuestros proyectos que potencian la calidad de vida. Cada proyecto es una declaración de nuestra promesa de calidad, diseño y valor duradero.</p>   
                </b-col>
                <b-col md="6" class="text-right pr-0" align-self="center">
                    <img class="img-fluid" src="../assets/imgs/nosotros.png" alt="">
                </b-col>
            </b-row>
        </b-container>
        <b-container class="carrouselNosotros">
            <b-row class="">
                <b-col>
                    <VueSlickCarousel v-bind="slickOptions" :arrows="true" :dots="false">
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyectos1.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyectos2.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyectos3.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyectos4.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyectos5.png" alt="">
                        </div>
                    </VueSlickCarousel>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="section2" fluid>
            <b-row>
                <b-col md="7" class="mb-4" align-self="center">
                    <img class="img-fluid" src="../assets/imgs/fotofamiliar(1).png" alt="">
                </b-col>
                <b-col md="5" align-self="center">
                    <h4>Cuidado con el detalle</h4>
                    <p>En ARIA LIFE cada detalle cuenta. Desde el diseño arquitectónico hasta la selección de materiales y la planificación urbana, nuestro enfoque integral asegura que cada desarrollo cumpla con los más altos estándares. Creemos firmemente que el verdadero lujo está en la atención al detalle y en crear espacios que inspiren.</p>
                </b-col>
            </b-row>
        </b-container>
        <Contact/>
        <div class="whatsapp">
            <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                
            </a>
            <b-button id="popover-target-1">
                <img src="../assets/imgs/whatsapp.png" alt="Whatsapp">
            </b-button>
            <b-popover target="popover-target-1" triggers="hover" placement="top">
                <b>Comunícate a:</b><br><br>
                <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                    Samara    
                </a>
                <br><br>
                <a href="https://api.whatsapp.com/send/?phone=526861924713&amp;app_absent=0" target="_blank">
                    Coto Sur 2
                </a>
            </b-popover>
        </div>
    </div>
</template>

<script>
    import Navbar from '../components/Navbar.vue'
    import Contact from '../components/Contact.vue'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: {
            VueSlickCarousel,
            Navbar,
            Contact
        },
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                }
            }
        }
    }
</script>

<style scoped>
.nosotros{
    padding-top: 200px;
}
.nosotros-col1{
    padding-left: 8%;
}
.section1{
    padding-bottom: 100px;
}
.section2{
    padding: 10% 5%;
}
.carrouselNosotros{
    max-width: 70vw !important;
}
.carrouselNosotros img{
    width: 100%;
}
@media (max-width: 992px) {
    .nosotros{
        padding-top: 130px;
    }
}
@media (max-width: 768px) {
    .section2{
        padding: 70px 5%;
    }
}
</style>